
import { enTranslations } from './en';
import { jaTranslations } from './ja';
import { koTranslations } from './ko';
import { zhCNTranslations } from './zh-CN';
import { zhTWTranslations } from './zh-TW';

export type TranslationKey = string;

// Define Language type
export type Language = 'en' | 'ja' | 'ko' | 'zh-CN' | 'zh-TW';

// すべての翻訳を一つのオブジェクトにまとめる
export const translations: Record<Language, Record<string, string>> = {
  'en': enTranslations,
  'ja': jaTranslations,
  'ko': koTranslations,
  'zh-CN': zhCNTranslations,
  'zh-TW': zhTWTranslations
};

// デフォルト言語
export const defaultLanguage: Language = 'ja';

// 使用可能な言語
export const availableLanguages = [
  { code: 'en' as Language, name: 'English' },
  { code: 'ja' as Language, name: '日本語' },
  { code: 'ko' as Language, name: '한국어' },
  { code: 'zh-CN' as Language, name: '简体中文' },
  { code: 'zh-TW' as Language, name: '繁體中文' },
];
